import { List, Create, Edit, View } from "../Components/index.js";

export default [
    {
        path: "/admin/user-flat",
        component: List,
        name: "user-flat-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/user-flat/:id/edit",
        component: Edit,
        name: "user-flat-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/user-flat/:id/view",
        component: View,
        name: "user-flat-view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/user-flat/create",
        component: Create,
        name: "user-flat-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/report/company-user-flat",
        component: () => import("../Components/ReportCompanyUsers.vue"),
        name: "company-user-flat",
        meta: {
            requiresAuth: true,
        },
    },
];
